import { BAR_STAGES, STAGE_NAMES, ageDays, ageIsLate, ageLabel, nextLabel } from "../../../../lib/giftingRules";
import type { GfEntry } from "../../../../types/gifting";
import { GfAvatar, GfCard, GfEmpty } from "../../ui/GfUi";
import { cardInfo, type PipelineCtx } from "./model";

/** 一覧ビュー（min-width 860・段階名ヘッダ10px）。行クリックでエントリーパネル */
export function ListView({
  entries,
  ctx,
  selectedId,
  onOpen,
}: {
  entries: GfEntry[];
  ctx: PipelineCtx;
  selectedId: string | null;
  onOpen: (dealId: string) => void;
}) {
  const rows = entries
    .map((e) => ({ e, age: ageDays(e, ctx.nowIso) }))
    .sort((a, b) => b.e.stage - a.e.stage || b.age - a.age);

  return (
    <GfCard flush>
      <div className="gf-table-wrap">
        <div className="gf-lv">
          <div className="gf-lv-row gf-lv-head">
            <span>クリエイター</span>
            <span>案件</span>
            <span className="gf-lv-stages">
              {BAR_STAGES.map((s) => (
                <span key={s}>{STAGE_NAMES[s]}</span>
              ))}
            </span>
            <span>次のアクション</span>
            <span>経過</span>
          </div>
          {rows.length === 0 && <GfEmpty>該当するエントリーはありません</GfEmpty>}
          {rows.map(({ e, age }) => {
            const info = cardInfo(e, ctx);
            return (
              <button
                type="button"
                key={e.id}
                className={`gf-lv-row gf-lv-body${selectedId === e.id ? " is-selected" : ""}`}
                onClick={() => onOpen(e.id)}
              >
                <span className="gf-lv-who">
                  <GfAvatar name={info.creatorName} size={28} />
                  <span className="gf-lv-who-text">
                    <span className="gf-lv-name">{info.creatorName}</span>
                    <span className="gf-lv-handle">{info.handle}</span>
                  </span>
                </span>
                <span className="gf-lv-deal">{info.campaignName}</span>
                <span className="gf-lv-dots">
                  {BAR_STAGES.map((s) => (
                    <span key={s} className={`${s <= e.stage ? "is-on" : ""}${s === e.stage ? " is-current" : ""}`} />
                  ))}
                </span>
                <span className="gf-lv-next">
                  <span>{nextLabel(e, info.campaign, ctx.nowIso)}</span>
                  {info.autoText && <span className="gf-lv-auto">{info.autoText}</span>}
                </span>
                <span className={`gf-lv-age${ageIsLate(age, e.stage) ? " is-late" : ""}`}>{ageLabel(age)}</span>
              </button>
            );
          })}
        </div>
      </div>
    </GfCard>
  );
}
